import axios from "axios";

export const addAffiliateAction = async (payload) => {
  const response = await axios.post(
    `${process.env.REACT_APP_BASE_URL}/affiliates/createAffiliate`,
    payload.affiliate,
    {
      headers: {
        Authorization: payload.token,
      },
    }
  );

  return response;
};

export const getAffiliateAction = async (payload) => {

  const response = await axios.get(
    `${process.env.REACT_APP_BASE_URL}/affiliates/getAllAffiliate?page=${payload?.page}&limit=${payload?.limit}&search=${payload?.search?payload?.search:""}`,
    {
      headers: {
        Authorization: payload.token,
      },
    }
  );

  return response;
};

export const getActiveAffiliateAction = async (payload) => {
  const response = await axios.get(
    `${process.env.REACT_APP_BASE_URL}/affiliates/getAllActiveAffiliate`,
    {
      headers: {
        Authorization: payload.token,
      },
    }
  );

  return response.data;
};

export const totalNumberOfAffiliateAction = async (payload) => {
  const response = await axios.get(
    `${process.env.REACT_APP_BASE_URL}/affiliates/totalNumberOfAffiliates`,
    {
      headers: {
        Authorization: payload,
      },
    }
  );

  return response.data;
};

//! needs to be implementted
export const getAffiliateByName = async (payload) => {
  const response = await axios.get(
    `${process.env.REACT_APP_BASE_URL}/affiliates/affiliateByName?affiliateName=${payload.name}`,
    {
      headers: {
        Authorization: payload.token,
      },
    }
  );

  return response.data;
};

export const updateAffiliateAction = async (payload) => {
  const response = await axios.patch(
    `${process.env.REACT_APP_BASE_URL}/affiliates/updateAffiliate?affiliateId=${payload.affiliateId}`,
    payload.affiliateUpdateBody,
    {
      headers: {
        Authorization: payload.token,
      },
    }
  );

  return response;
};
